import { idType } from '@src/types';
import { Dispatch, MutableRefObject, SetStateAction } from 'react';
import type { AssignmentModeType } from '@store/slices/Assignment/assignmentSlice';
import type { contractorReadyForTransmitType } from '@store/rtk/assignment';
import type { GridPreferenceKey } from '@store/rtk/users';
import { TableData } from '@uikit/Tables/types';

export const ASSIGNMENT_ROW_DRAG_TYPE = 'application/x-assignment-row';

export const CONFIRMED_BY_MIN_LENGTH = 4;
export const CONFIRMED_BY_MAX_LENGTH = 100;
export const AUX_CON_CONFIRMED_BY_PATTERN = /^[A-Za-z ]{4,100}$/;
export const CONTRACTOR_CLOSEOUT_LOCK_TOOLTIP =
  'Locked due to the contractor close out';

export type AssignmentContractorsProps = {
  selectedContractor: idType;
  assignmentTargetContractor: idType;
  canEditAssignment: boolean;
  searchReady: boolean;
  refreshKey: number;
  transmitStatusesRefreshRef: MutableRefObject<(() => void) | null>;
  contractorTransmitStatuses: Record<string, contractorReadyForTransmitType>;
  setContractorTransmitStatuses: Dispatch<
    SetStateAction<Record<string, contractorReadyForTransmitType>>
  >;
  setSelectedContractor: Dispatch<SetStateAction<idType>>;
  setAssignmentTargetContractor: Dispatch<SetStateAction<idType>>;
  setRefreshKey: Dispatch<SetStateAction<number>>;
  dataTestId?: string;
};

export type AssignmentSegmentDetailProps = {
  selectedSegment: idType;
  selectedRide: idType;
  canEditAssignment: boolean;
  dataTestId?: string;
};

export type AssignmentGridProps = {
  isContractorVersion: boolean;
  selectedContractor: idType;
  assignmentTargetContractor: idType;
  canEditAssignment: boolean;
  refreshKey: number;
  hasSelectedContractorTransmitIcon?: boolean;
  setSelectedSegment: Dispatch<SetStateAction<idType>>;
  setSelectedSegmentNew: Dispatch<SetStateAction<any>>;
  selectedSegment: any;
  setSelectedContractor: Dispatch<SetStateAction<idType>>;
  setSelectedRide: Dispatch<SetStateAction<idType>>;
  setAssignmentTargetContractor: Dispatch<SetStateAction<idType>>;
  setRefreshKey: Dispatch<SetStateAction<number>>;
  refreshContractorTransmitStatuses?: () => void;
  onGridLoadingChange: (isLoading: boolean) => void;
  dataTestId?: string;
  canEdit: boolean;
  mockTableData?: TableData;
  mockMarketplaceTableData?: TableData;
  mockTitle?: string;
  // TODO: replace with the real AUX-CON payer flag once it is exposed by the backend.
  isAuxConPayer?: boolean;
};

export type OstToggleCommand = { target: boolean; nonce: number };

export type AssignmentGridTableProps = {
  isContractorVersion: boolean;
  isRide: boolean;
  selectedContractor: idType;
  assignmentModeActive?: boolean;
  assignmentModeType?: AssignmentModeType;
  canEditAssignment: boolean;
  setSelectedSegment: Dispatch<SetStateAction<idType>>;
  setSelectedSegmentNew: Dispatch<SetStateAction<any>>;
  setSelectedRide: Dispatch<SetStateAction<idType>>;
  selectedSegment: any;
  canEdit: boolean;
  contextAssignmentSaving: boolean;
  onContextAssign: (
    contractorId: idType,
    rows: Array<Record<string, any>>,
    assignmentType: 'ride' | 'standingOrder'
  ) => Promise<void>;
  onAssignmentGridReload?: () => void;
  mockTableData?: TableData;
  ostToggleCommand?: OstToggleCommand | null;
  onOstAllColumnsVisibleChange?: (allVisible: boolean) => void;
  columnLayoutKey?: GridPreferenceKey | null;
};

export const UNASSIGNED_CONTRACTOR_IDS = new Set(['-1', '999999999']);
